import { Icon, getSvgIcon } from '@helpers/icons';
import { isSSR } from '@helpers/ssr';
import { highlightTitleWords } from '@helpers/utils';
import * as React from 'react';
import Modal from '../Modal/Modal';
import S from './VideoPrompt.styles';
const VideoPrompt = (props) => {
    const videoRef = React.useRef(null);
    const [modalOpen, setModalOpen] = React.useState(false);
    React.useEffect(() => {
        const container = videoRef.current;
        if (!modalOpen || !container) {
            return;
        }
        // Wistia embed code
        const script1 = document.createElement('script');
        script1.src = `https://fast.wistia.com/embed/medias/${props.videoId}.jsonp`;
        script1.async = true;
        const script2 = document.createElement('script');
        script2.src = 'https://fast.wistia.com/assets/external/E-v1.js';
        script2.async = true;
        const div = document.createElement('div');
        div.innerHTML = `<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_${props.videoId} seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/${props.videoId}/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>`;
        container.appendChild(script1);
        container.appendChild(script2);
        container.appendChild(div);
        return () => {
            // Cleanup code
            container.innerHTML = '';
        };
    }, [modalOpen]);
    // Autoplay video when it's loaded in
    const observer = React.useMemo(() => !isSSR()
        ? new MutationObserver(() => {
            const container = videoRef.current;
            if (!container)
                return;
            const video = container.querySelector('video');
            if (video && !video.played.length) {
                video.play();
            }
        })
        : null, []);
    React.useEffect(() => {
        const container = videoRef.current;
        if (!container || !observer)
            return;
        observer.observe(container, { childList: true, subtree: true });
        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [modalOpen]);
    if (!props.videoId) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Container, { onClick: () => setModalOpen(true) },
            React.createElement(S.TextWrapper, null,
                React.createElement(S.Text, { dangerouslySetInnerHTML: { __html: highlightTitleWords(props.text) } }),
                React.createElement(S.Icon, null, getSvgIcon(Icon.Play))),
            getSvgIcon(Icon.CompanyBrandLogoeye)),
        React.createElement(Modal, { id: `video-prompt-${props.videoId}`, ariaLabel: "Video embed modal", isOpen: modalOpen, onClose: () => setModalOpen(false), showBackground: true, closeOnBackground: true, showClose: true },
            React.createElement("div", { ref: videoRef }))));
};
export default VideoPrompt;
